import { FC, useContext } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Language } from "@/model/Language/Language";

import { TranslationContext } from "@/app/providers";

import { GetLanguageValueAsString } from "@/app/application/Translate";


interface CustomCloseIconProps {
	onClick: () => void;
}
export const CustomCloseIcon: FC<CustomCloseIconProps> = (props) => {
	const translation: Language | null = useContext(TranslationContext);
	return (
		<IconButton
			aria-label={GetLanguageValueAsString(translation, "Auto.Features.Training.Ui.Components.CustomCloseIcon.L13C15.Close", "close")}
			onClick={props.onClick}
			sx={{
				position: "absolute",
				right: 10,
				top: 10,
				borderRadius: 1,
				color: "text.secondary",
				border: (theme) => `1px solid ${theme.palette.divider}`,
				backgroundColor: "background.paper",
				"&:hover": {
					backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.04),
					color: "text.primary",
				},
			}}
		>
			<CloseIcon />
		</IconButton>
	);
};
